/* Reseñas propias de la ficha: "Ver más reseñas", filtros y visor de fotos.
   Las primeras 10 reseñas ya vienen en el HTML (sections/lenz-reviews.liquid);
   esto solo agrega interacción. El markup de las tarjetas debe coincidir con
   snippets/lenz-review-card.liquid. La base de la API sale de data-api. */
(function () {
  'use strict';
  var root = document.getElementById('resenas');
  if (!root || !root.getAttribute('data-api')) return;

  var API = root.getAttribute('data-api').replace(/\/+$/, '');
  var PID = root.getAttribute('data-product-id');
  var PER = 10;
  var list = root.querySelector('[data-lenz-list]');
  var moreBtn = root.querySelector('[data-lenz-more]');
  var status = root.querySelector('[data-lenz-status]');
  var filters = root.querySelector('[data-lenz-filters]');
  if (!list) return;

  var initialHTML = list.innerHTML;
  var total = parseInt(root.getAttribute('data-count'), 10) || 0;
  var initialPages = Math.ceil(total / PER);
  var st = { rating: '', photos: false, page: 1, pages: initialPages, busy: false, more: initialPages > 1 };
  var reqId = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function nl2br(s) { return esc(s).replace(/\r?\n/g, '<br>'); }
  function fmtDate(d) {
    var p = String(d || '').split('-');
    return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : '';
  }
  function sized(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function card(r) {
    var initial = (String(r.name || '').trim().charAt(0) || '?').toUpperCase();
    var date = fmtDate(r.date);
    var photos = (r.photos || []).map(function (p) {
      return '<a class="lenz-reviews__photo" href="' + esc(sized(p.url, 1600)) + '" target="_blank" rel="noopener" data-lenz-photo data-alt="' + esc(p.alt) + '">' +
        '<img src="' + esc(sized(p.url, 240)) + '" alt="' + esc(p.alt) + '" width="88" height="88" loading="lazy" decoding="async"></a>';
    }).join('');
    var rd = r.reply && r.reply.body ? fmtDate(r.reply.date) : '';
    return '<article class="lenz-reviews__card" data-rating="' + esc(r.rating) + '" data-photos="' + (r.photos || []).length + '">' +
      '<span class="lenz-reviews__stars" role="img" aria-label="' + esc(r.rating) + ' de 5 estrellas" style="--lr-pct: ' + (r.rating * 20) + '%"></span>' +
      '<header class="lenz-reviews__author"><span class="lenz-reviews__avatar" aria-hidden="true">' + esc(initial) + '</span>' +
      '<span class="lenz-reviews__name">' + esc(r.name) + '</span>' +
      (r.verified ? '<span class="lenz-reviews__verified">Compra verificada</span>' : '') + '</header>' +
      (date ? '<time class="lenz-reviews__date" datetime="' + esc(r.date) + '">' + date + '</time>' : '') +
      '<p class="lenz-reviews__body">' + nl2br(r.body) + '</p>' +
      (photos ? '<div class="lenz-reviews__photos">' + photos + '</div>' : '') +
      (r.reply && r.reply.body ? '<div class="lenz-reviews__reply"><p class="lenz-reviews__reply-head">Respuesta de Lenz' +
        (rd ? ' <time datetime="' + esc(r.reply.date) + '">· ' + rd + '</time>' : '') + '</p>' +
        '<p class="lenz-reviews__reply-body">' + nl2br(r.reply.body) + '</p></div>' : '') +
      '</article>';
  }

  function say(html) {
    if (!status) return;
    status.hidden = !html;
    status.innerHTML = html || '';
  }
  function syncMore() {
    if (!moreBtn) return;
    moreBtn.hidden = !st.more;
    moreBtn.disabled = st.busy;
    moreBtn.textContent = st.busy ? 'Cargando…' : 'Ver más reseñas';
  }

  function fetchPage(page) {
    var q = '?page=' + page + '&per_page=' + PER;
    if (st.rating) q += '&rating=' + encodeURIComponent(st.rating);
    if (st.photos) q += '&sort=photos';
    return fetch(API + '/api/reviews/product/' + encodeURIComponent(PID) + q, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json();
      });
  }

  // reset = true: vacía la lista y trae la página 1 con el filtro actual.
  function load(reset) {
    if (st.busy && !reset) return;
    var my = ++reqId;
    var page = reset ? 1 : st.page + 1;
    st.busy = true;
    say('');
    if (reset) list.setAttribute('aria-busy', 'true');
    syncMore();
    fetchPage(page).then(function (data) {
      if (my !== reqId) return;
      var rs = data.reviews || [];
      var keep = st.photos ? rs.filter(function (r) { return r.photos && r.photos.length; }) : rs;
      // sort=photos trae primero las que tienen fotos: al llegar a una sin foto se termina.
      var more = page < (data.total_pages || 1) && (!st.photos || keep.length === rs.length);
      var html = keep.map(card).join('');
      if (reset) list.innerHTML = html; else list.insertAdjacentHTML('beforeend', html);
      st.page = page;
      st.pages = data.total_pages || 1;
      st.more = more;
      if (reset && !keep.length) say('No hay reseñas con este filtro.');
    }).catch(function () {
      if (my !== reqId) return;
      say('No pudimos cargar las reseñas. <a href="#" data-lenz-retry>Reintentar</a>');
      if (reset) list.innerHTML = '';
    }).then(function () {
      if (my !== reqId) return;
      st.busy = false;
      list.removeAttribute('aria-busy');
      syncMore();
    });
  }

  function restoreInitial() {
    reqId++;
    st.page = 1; st.pages = initialPages; st.more = initialPages > 1; st.busy = false;
    list.innerHTML = initialHTML;
    list.removeAttribute('aria-busy');
    say('');
    syncMore();
  }

  if (filters) {
    filters.hidden = false;
    filters.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]');
      if (!b) return;
      var kind = b.getAttribute('data-filter');
      var wasOn = b.getAttribute('aria-pressed') === 'true';
      st.rating = ''; st.photos = false;
      if (kind === 'rating' && !wasOn) st.rating = b.getAttribute('data-value');
      if (kind === 'photos' && !wasOn) st.photos = true;
      Array.prototype.forEach.call(filters.querySelectorAll('[data-filter]'), function (x) { x.setAttribute('aria-pressed', 'false'); });
      var active = (kind === 'all' || wasOn) ? filters.querySelector('[data-filter=all]') : b;
      active.setAttribute('aria-pressed', 'true');
      if (!st.rating && !st.photos) restoreInitial(); else load(true);
    });
  }
  if (moreBtn) {
    moreBtn.addEventListener('click', function () { load(false); });
    syncMore();
  }
  if (status) {
    status.addEventListener('click', function (e) {
      if (!e.target.closest('[data-lenz-retry]')) return;
      e.preventDefault();
      if (!list.children.length) load(true); else load(false);
    });
  }

  /* ───── Visor de fotos ───── */
  var box, imgEl, capEl, items = [], idx = 0, opener = null;
  function build() {
    box = document.createElement('div');
    box.className = 'lenz-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Fotos de la reseña');
    box.innerHTML = '<button type="button" class="lenz-lightbox__close" aria-label="Cerrar">&times;</button>' +
      '<button type="button" class="lenz-lightbox__prev" aria-label="Foto anterior">&#8249;</button>' +
      '<img class="lenz-lightbox__img" alt="">' +
      '<button type="button" class="lenz-lightbox__next" aria-label="Foto siguiente">&#8250;</button>' +
      '<p class="lenz-lightbox__cap"></p>';
    imgEl = box.querySelector('img');
    capEl = box.querySelector('.lenz-lightbox__cap');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.lenz-lightbox__close') || e.target === box) close();
      else if (e.target.closest('.lenz-lightbox__prev')) show(idx - 1);
      else if (e.target.closest('.lenz-lightbox__next')) show(idx + 1);
    });
    document.body.appendChild(box);
  }
  function show(i) {
    idx = (i + items.length) % items.length;
    var a = items[idx];
    imgEl.src = a.getAttribute('href');
    imgEl.alt = a.getAttribute('data-alt') || '';
    capEl.textContent = items.length > 1 ? (idx + 1) + ' / ' + items.length : '';
    var nav = items.length > 1;
    box.querySelector('.lenz-lightbox__prev').hidden = !nav;
    box.querySelector('.lenz-lightbox__next').hidden = !nav;
  }
  function open(a) {
    if (!box) build();
    items = Array.prototype.slice.call(a.closest('.lenz-reviews__photos').querySelectorAll('[data-lenz-photo]'));
    opener = a;
    show(items.indexOf(a));
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey, true);
    box.querySelector('.lenz-lightbox__close').focus();
  }
  function close() {
    box.hidden = true;
    imgEl.removeAttribute('src');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey, true);
    if (opener) opener.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft' && items.length > 1) show(idx - 1);
    else if (e.key === 'ArrowRight' && items.length > 1) show(idx + 1);
    else if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(box.querySelectorAll('button'), function (b) { return !b.hidden; });
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lenz-photo]');
    if (!a) return;
    e.preventDefault();
    open(a);
  });
})();
